import { Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { PHONE_LINK, FONT_BODY, NAVY, GOLD, isSpanishPath } from "../lib/constants";

export const StickyCallButton = () => {
  const isEs = isSpanishPath(useLocation().pathname);
  return (
  <a
    href={PHONE_LINK}
    data-testid="sticky-call-btn"
    className="fixed bottom-6 right-6 z-50 md:hidden flex items-center gap-2 px-5 py-3 shadow-2xl transition-transform hover:scale-105 sticky-call-pulse"
    style={{
      background: NAVY,
      color: "#FFFFFF",
      border: `2px solid ${GOLD}`,
      borderRadius: "50px",
      fontFamily: FONT_BODY,
      fontWeight: 700,
      fontSize: "14px",
    }}
    aria-label={isEs ? "Llamar a Cindyrella Cleaning" : "Call Cindyrella Cleaning"}
  >
    <Phone size={16} />
    {isEs ? "Llamar ahora" : "Call Now"}
  </a>
  );
};
